import React from 'react';

const Home = () => {
  return (
    <div className='text-center text-2xl flex justify-center flex-col items-center gap-6'>
    <div>Welcome to dashboard Admin</div>
  </div>
  );
};

export default Home;
